import { render, staticRenderFns } from "./SelfserviceView.vue?vue&type=template&id=dff5c76c&scoped=true&"
import script from "./SelfserviceView.vue?vue&type=script&lang=js&"
export * from "./SelfserviceView.vue?vue&type=script&lang=js&"
import style0 from "./SelfserviceView.vue?vue&type=style&index=0&id=dff5c76c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff5c76c",
  null
  
)

export default component.exports